import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_PROJECTEDACCRUAL_LOAD_BY_TRIAL_ID,
    ACTION_PROJECTEDACCRUAL_LOAD_BY_ID,

    ACTION_PROJECTEDACCRUAL_SAVE,

    IProjectedAccrualLoadByTrialIdAction,
    IProjectedAccrualLoadByIdAction,
    IProjectedAccrualLoadFailureAction,
    IProjectedAccrualLoadSuccessAction,

    IProjectedAccrualSaveAction,
    IProjectedAccrualSaveSuccessAction,
    IProjectedAccrualSaveFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,
    IProjectedAccrualUpdateSuccessAction,
    IProjectedAccrualUpdateFailureAction,
    ACTION_PROJECTEDACCRUAL_UPDATE,
    IProjectedAccrualUpdateAction,
    UpdateSuccess,
    UpdateFailure,

} from "../actions/projectedAccrual";
import { projectedAccrualApi } from "../services/projectedAccrual";


export const
    getProjectedAccrualByTrialIdEpic = (action$): Observable<IProjectedAccrualLoadSuccessAction | IProjectedAccrualLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTEDACCRUAL_LOAD_BY_TRIAL_ID)
            .mergeMap((action: IProjectedAccrualLoadByTrialIdAction) => {
                return projectedAccrualApi
                    .getProjectedAccrualByTrialId(action.trialId)
                    .map(response => 
                        LoadSuccess(response.projectedAccruals, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getProjectedAccrualByIdEpic = (action$): Observable<IProjectedAccrualLoadSuccessAction | IProjectedAccrualLoadFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTEDACCRUAL_LOAD_BY_ID)
            .mergeMap((action: IProjectedAccrualLoadByIdAction) => {
                return projectedAccrualApi
                    .getProjectedAccrualById(action.id)
                    .map(response =>
                        LoadSuccess(response.projectedAccrual, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setProjectedAccrualEpic = (action$): Observable<IProjectedAccrualSaveSuccessAction | IProjectedAccrualSaveFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTEDACCRUAL_SAVE)
            .mergeMap((action: IProjectedAccrualSaveAction) => {
                return projectedAccrualApi
                    .setProjectedAccrual(action.data)
                    .map(response => {

                        return SaveSuccess(response.projectedAccrual, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    updateProjectedAccrualEpic = (action$): Observable<IProjectedAccrualUpdateSuccessAction | IProjectedAccrualUpdateFailureAction> => {
        return action$
            .ofType(ACTION_PROJECTEDACCRUAL_UPDATE)
            .mergeMap((action: IProjectedAccrualUpdateAction) => {
                return projectedAccrualApi
                    .updateProjectedAccrual(action.trialId, action.data)
                    .map(response => {

                        return UpdateSuccess(response.projectedAccruals, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(UpdateFailure(error.responseStatus))
                    )
            });
    }